import React, { useEffect } from 'react';
import classNames from 'classnames';
import styles from './assets/program-book.module.scss';
import {
    getProgramBookEntity,
    asyncCreateFilesProgramBook,
    getFilesProgramBook,
    deleteFileProgramBook,
} from 'src/store/actions/program-book-actions';
import AdminLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import Form from '../../components/ProgramBookForm';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../../../store/reducers';
import { groupProgramBookEntity } from './helper.groupProgramEntity';
import Loader from 'src/components/Loader';

export interface StateProps {}

export interface DispatchProps {}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}
export interface Props extends StateProps, DispatchProps, OwnProps {}

const ProgramBookCreateScreen: React.FunctionComponent<Props> = (props: Props) => {
    const {
        match: {
            params: { id },
        },
    } = props;
    const programBook = useSelector((state: StoreState) => state.programBooks);
    const { current, currentFiles, inProgress, miniLoaderFor } = programBook;
    const dispatch = useDispatch();

    useEffect(() => {
        if (!current || `${current.id}` !== `${id}`) {
            dispatch(getProgramBookEntity(id, '1'));
            dispatch(getFilesProgramBook(id));
        }
        // eslint-disable-next-line
    }, [id]);
    const handleAdd = async (files: any) => {
        await asyncCreateFilesProgramBook(id, files, dispatch);
    };
    let dataBook: any = {};
    if (current) {
        dataBook = groupProgramBookEntity(current);
    }

    const handeRemove = (fileId: string | number) => {
        dispatch(deleteFileProgramBook(fileId));
    };
    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        //if (currentFiles?.length) {
            handleSubmit(e);
        //} else {
         //   toast.error('Please upload a document');
         //   return false;
        //}
    };
    return (
        <AdminLayout>
            <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>PROGRAM BOOK</h2>
            </div>
            <div className={classNames(styles.wrapForm)}>
                {inProgress ? <Loader/> : null}
                <Form
                    files={currentFiles}
                    //setFiles={handleAdd}
                    handleSub={handleSub}
                    miniLoaderFor={miniLoaderFor}
                    removeFile={(id) => handeRemove(id)}
                    setFiles={(currentFiles: any) => handleAdd(currentFiles)}
                    initialValues={{ ...dataBook }}
                />
            </div>
        </AdminLayout>
    );
};

export default ProgramBookCreateScreen;
